String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

Object.byString = function(o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};



//////////////////
// WEBPACK FOOTER
// ./helpers/index.js
// module id = TEyX
// module chunks = 18